export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPneupopis';
export const NAME = 'PopisPneu';
